import { Children } from "react";

const MIN_WIDTH = {
  3: "11rem",
  4: "10rem",
  5: "9rem",
  6: "8.5rem",
};

export default function StatCardGrid({ cols = 4, className = "", children }) {
  const items = Children.toArray(children);
  const minWidth = MIN_WIDTH[cols] ?? MIN_WIDTH[4];

  return (
    <div className={`mb-4 flex flex-nowrap items-stretch gap-2 overflow-x-auto pb-0.5 ${className}`}>
      {items.map((child, index) => (
        <div
          key={child?.key ?? index}
          className="flex min-w-0 flex-1 shrink-0 flex-col self-stretch"
          style={{ minWidth }}
        >
          {child}
        </div>
      ))}
    </div>
  );
}
